import React from 'react'
import MovieListItemArthouse from './MovieListItemArthouse'
import MovieListItemStandard from './MovieListItemStandard'

const MovieListItem = ({
    itemData, 
    itemLink,
    itemDetailsOpen, 
    scrollToPosition, 
    id, 
    hideCinemaSelector,
    isMobile,
    itemsData, 
    isOverview, 
    translation,
    closingDetails, 
    hiddenAttributes,
    showMobileMovieTimes, 
    toggleMovieDatesOnMobileView, 
    toggleMovieTimesOnMobileView, 
    openItemDetails, 
    dayFilters,
    closeItemDetails, 
    currentDateActive,
    displaySidebarRight,
    theme,
    displaySidebarRightSecond,
    programOverviewListStyle,
    isSingleMovie,
    informationStyling,
    performancePageOpen, 
    stripeAppearance,
    detailsStyling,
    ignoreAttributesForPerformanceFilter,
    overviewFilterIgnoreOnPerformances,
    posterStyling,
    activePerformance, 
    attributeStyling,
    onOpenPerformancePage, 
    onClosePerformancePage,
    currentBrowserWidth,
    queryStringValues,
    clusterCinemaActive,
    clusterCinemaOption,
    activeCinema,
    currentCinemaType
}) => {

    return theme === 'Arthouse' ? (
        <MovieListItemArthouse 
            itemData={itemData} 
            informationStyling={informationStyling}
            itemLink={itemLink}
            itemDetailsOpen={itemDetailsOpen} 
            scrollToPosition={scrollToPosition} 
            id={id} 
            hideCinemaSelector={hideCinemaSelector}
            isMobile={isMobile}
            detailsStyling={detailsStyling}
            hiddenAttributes={hiddenAttributes}
            itemsData={itemsData} 
            isOverview={isOverview} 
            translation={translation}
            verviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
            closingDetails={closingDetails} 
            showMobileMovieTimes={showMobileMovieTimes} 
            toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView} 
            openItemDetails={openItemDetails} 
            dayFilters={dayFilters}
            closeItemDetails={closeItemDetails} 
            currentDateActive={currentDateActive}
            displaySidebarRight={displaySidebarRight}
            theme={theme}
            displaySidebarRightSecond={displaySidebarRightSecond}
            isSingleMovie={isSingleMovie}
            performancePageOpen={performancePageOpen} 
            stripeAppearance={stripeAppearance}
            ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
            posterStyling={posterStyling}
            activePerformance={activePerformance} 
            attributeStyling={attributeStyling}
            onOpenPerformancePage={onOpenPerformancePage} 
            onClosePerformancePage={onClosePerformancePage}
            currentBrowserWidth={currentBrowserWidth}
            queryStringValues={queryStringValues}
            clusterCinemaActive={clusterCinemaActive}
            clusterCinemaOption={clusterCinemaOption}
            activeCinema={activeCinema}
            currentCinemaType={currentCinemaType}
        />
    ) : (
        <MovieListItemStandard 
            itemData={itemData} 
            itemLink={itemLink}
            itemDetailsOpen={itemDetailsOpen} 
            scrollToPosition={scrollToPosition} 
            id={id} 
            hideCinemaSelector={hideCinemaSelector}
            isMobile={isMobile}
            itemsData={itemsData} 
            detailsStyling={detailsStyling}
            informationStyling={informationStyling}
            isOverview={isOverview} 
            hiddenAttributes={hiddenAttributes}
            translation={translation}
            closingDetails={closingDetails} 
            verviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
            showMobileMovieTimes={showMobileMovieTimes} 
            toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView} 
            toggleMovieTimesOnMobileView={toggleMovieTimesOnMobileView} 
            openItemDetails={openItemDetails} 
            dayFilters={dayFilters}
            closeItemDetails={closeItemDetails} 
            currentDateActive={currentDateActive}
            displaySidebarRight={displaySidebarRight}
            programOverviewListStyle={programOverviewListStyle}
            theme={theme}
            displaySidebarRightSecond={displaySidebarRightSecond}
            isSingleMovie={isSingleMovie}
            performancePageOpen={performancePageOpen} 
            ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
            activePerformance={activePerformance} 
            attributeStyling={attributeStyling}
            onOpenPerformancePage={onOpenPerformancePage} 
            onClosePerformancePage={onClosePerformancePage}
            currentBrowserWidth={currentBrowserWidth}
            queryStringValues={queryStringValues}
            clusterCinemaActive={clusterCinemaActive}
            clusterCinemaOption={clusterCinemaOption}
            activeCinema={activeCinema}
            currentCinemaType={currentCinemaType}
        />
    )

}
export default MovieListItem